/* Dashboard (ATK staff) password reset.
   Uses plain fetch like loginUser: these calls happen while logged out, so they
   must skip axiosInstance's auth header and its 403 → refresh-token retry.
   The backend has no staff-specific reset: staff use the same /api/users flow as citizens.
   The one admin-only call is /admin/set-password, used by the link emailed to newly created staff. */
const BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}/api`;

const send = async (path, body, method = 'POST') => {
    const response = await fetch(`${BASE_URL}${path}`, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });

    let data = {};
    try {
        data = await response.json();
    } catch {
        // empty / non-JSON body
    }

    if (!response.ok || data?.success === false) {
        const error = new Error(data?.message || data?.error || 'Request failed');
        error.status = response.status;
        throw error;
    }
    return data;
};

/* Step 1 — email a one-time 4-digit code */
export const requestResetCode = (email) => send('/users/forgot-password', { email });

/* Step 2 — exchange the code for a 10-minute reset token ({ data: { reset_token } }); 5 wrong codes burn it */
export const verifyResetCode = (email, code) => send('/users/verify-code', { email, code });

/* Step 3 — set the new password using that token */
export const resetPassword = (email, resetToken, password) =>
    send('/users/reset-password', { email, reset_token: resetToken, password }, 'PATCH');

/* New staff account — the token comes from the emailed /set-password?token=... link (valid 24h, single use) */
export const setInitialPassword = (token, password) => send('/admin/set-password', { token, password });
